import type { SystemEvent } from '@/server/api/routers/system';

export type SystemEventsProps = {
  commitSha: string;
  serverStartTime: number;
};

/**
 * Update is needed if:
 * - The server is newer than the client
 * - The server commit is different from the client commit
 */
export function detectNewVersion(options: {
  /**
   * The server data.
   */
  serverData: SystemEvent;
  /**
   * The client data.
   */
  clientData: SystemEventsProps;
  /**
   * The timeout reference.
   */
  timeoutRef: React.RefObject<NodeJS.Timeout | null>;
  /**
   * The delay before firing the callback.
   */
  delay: number;
  /**
   * The callback to fire when a new version is detected and the delay has passed.
   */
  onNewVersion: () => void;
}) {
  if (!options.clientData.commitSha || !options.serverData.commitSha) {
    return;
  }
  const { serverData, clientData, timeoutRef, delay, onNewVersion } = options;
  const clientAge = Date.now() - clientData.serverStartTime;
  const isServerNewerThanClient = serverData.age < clientAge;

  if (serverData.commitSha !== clientData.commitSha && isServerNewerThanClient) {
    if (!timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        onNewVersion();
        timeoutRef.current = null;
      }, delay);
    }
  } else if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
}
